import { Instance, SnapshotOut, types } from 'mobx-state-tree'

export const ScheduleSingleDateDataModel = types.model('ScheduleSingleDateData', {
  shift_id: types.maybeNull(types.number),
  sps: types.map(types.number),
})

export type ScheduleSingleDateType = SnapshotOut<typeof ScheduleSingleDateDataModel>
export type ScheduleSingleDateInstance = Instance<typeof ScheduleSingleDateDataModel>
